import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const AirTagIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9 1C9.55228 1 10 1.44772 10 2V4.76168C10 5.15915 10.2405 5.51121 10.5808 5.71666C12.0306 6.59209 13 8.18284 13 10C13 12.7614 10.7614 15 8 15C5.23858 15 3 12.7614 3 10C3 8.18284 3.96938 6.59209 5.41922 5.71666C5.75948 5.51121 6 5.15915 6 4.76168V2C6 1.44771 6.44772 1 7 1H9ZM8 13.5C9.933 13.5 11.5 11.933 11.5 10C11.5 8.067 9.933 6.5 8 6.5C6.067 6.5 4.5 8.067 4.5 10C4.5 11.933 6.067 13.5 8 13.5Z"
		></path>
	</svg>
))
